import { withStyles } from '@material-ui/core';
import React, { useRef, useState } from 'react';
import { compose } from 'recompose';
import { ArrowLeftIcon, ArrowRightIcon } from '../../../../components/Common/Arrows/Arrows';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MagicSliderDots from 'react-magic-slider-dots';
import 'react-magic-slider-dots/dist/magic-dots.css';
import './list.css'

const styles = theme => ({
    listContainer: {
        overflow:'hidden',
        height: 'calc(686px - 48px)',
        position: 'relative',
    },
    cardsContainer: {
        height: '100%',
    },
    controlOutter: {
        display: 'flex',
        justifyContent: 'center'
    },
    controlWrap: {
        width: 1286,
        top: 570,
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    controlButtons: {
        flexDirection: 'column',
        alignSelf: 'center',
        border: 'solid 2px rgba(235, 235, 235, 0.5)',
        borderRadius: 4,
        width: 84,
        height: 38,
    },
    disableIcon:{
        fill: theme.newUI.color.gray
    },
    activeIcon:{
        cursor: 'pointer',
        fill: '#fff'
    },
    leftButton: {
        width: 42,
        height: 38,
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        border: 'none',
    },
    rightButton: {
        width: 42,
        height: 38,
        borderRadius: 4,
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        border: 'none',
        borderLeft: 'solid 2px rgba(235, 235, 235, 0.5)',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    }
})


const List = (props) => {
    const {classes, children} = props
    const [activeIndex, setActiveIndex] = useState(0)
    const sliderRef = useRef()

    const activeLeftArrow = activeIndex !== 0
    const activeRightArrow = activeIndex !== children.length - 1

    const scrollToRight = () => {
        sliderRef.current.slickNext();
    }

    const scrollToLeft = () => {
        sliderRef.current.slickPrev();
    }
    const beforeChangeActiveIndex = (prev, next) => {
        setActiveIndex(next)
    }

    const renderListControlButtons = () => {
        return (
        <div data-intrcm-id="List_ki7cmp0v" className={classes.controlOutter}>
            <div data-intrcm-id="List_d7jy24ys" className={classes.controlWrap}>
                <div data-intrcm-id="List_po24ti5b" className={classes.controlButtons}>
                    <button className={classes.leftButton} onClick={scrollToLeft}>
                        <ArrowLeftIcon 
                            backgroundColor="transparent"
                            className={activeLeftArrow ? classes.activeIcon: classes.disableIcon}/>
                    </button>
                    <button className={classes.rightButton} onClick={scrollToRight}>
                        <ArrowRightIcon
                            backgroundColor="transparent"
                            className={activeRightArrow ? classes.activeIcon: classes.disableIcon}/>
                    </button>
                </div>
            </div>
        </div>
        )
    }

    const settings = {
        className: "slider variable-width",
        speed: 300,
        dots: true,
        infinite: false,
        centerMode: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        variableWidth: true,
        arrows: false,
        appendDots: dots => <MagicSliderDots dots={dots} numDotsToShow={12} dotWidth={30} />,
        beforeChange: beforeChangeActiveIndex
      };

        return (
            <div data-intrcm-id="List_1gquvjja" className={classes.listContainer} >
                <div data-intrcm-id="List_quegf1yu" className={classes.cardsContainer}>
                    <Slider ref={c => (sliderRef.current = c)} {...settings}>
                        {children}
                    </Slider>
                </div>
                {renderListControlButtons()}
            </div>
        )
}

export default compose(withStyles(styles))(List);
